var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 12,
    x: 5.333,
    y: 8,
    stroke: "#222",
    strokeWidth: 1.5,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M11.333 3.25A2.75 2.75 0 0 0 8.583 6h1.5c0-.69.56-1.25 1.25-1.25h6c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25v1.5a2.75 2.75 0 0 0 2.75-2.75V6a2.75 2.75 0 0 0-2.75-2.75z",
    clipRule: "evenodd"
  })));
};
export default SvgCopy;